module.exports = __webpack_public_path__ + "app_assets/fonts/Videogular.ttf";